import { call, fork, put, take } from 'redux-saga/effects';

// Type
import { TAbcWords } from 'pages/AllDrugsVocabulary/type';

// Actions
import * as actionsCreator from './reducer';

// Start Sagas
export function* allDrugsVocabularySagaStart(api: any, action: any) {
	yield fork(getABCWatcher, api, action);
}

/**
 * Get thesaurus by id Watcher
 *
 * @param {function} api - api object
 * @param {object} action - action from dispatch
 * @returns
 */
export function* getABCWatcher(api: any, action: any): Generator<any, void, any> {
	while (true) {
		try {
			yield take(
				actionsCreator.getABC.type
			);

			const res = yield call(api.request, 'getProductsDictionary');

			if (!res?.ok) {
				yield put(actionsCreator.getABCError());
			} else {
				const dataWithoutHtmlTag = res?.data?.map((item: TAbcWords) => {
					const div = document.createElement('div');
					div.innerHTML = item.drug || '';
					return { ...item, drug: div.innerText };
				});

				const sortedArrayAlphabet = dataWithoutHtmlTag?.sort((a: TAbcWords, b: TAbcWords) => {
					const drugA = a?.drug || '';
					const drugB = b?.drug || '';
					return drugA.localeCompare(drugB);
				});

				const alphabet = sortedArrayAlphabet?.reduce((acc: { letter: string; count: number }[], item: {
					drug?: string;
					impuritiesCount: number
				}) => {
					if (item.drug) {
						const firstLetter = item.drug[0].toUpperCase();
						const existing = acc.find(entry => entry.letter === firstLetter);
						if (existing) {
							existing.count += item.impuritiesCount;
						} else {
							acc.push({ letter: firstLetter, count: item.impuritiesCount });
						}
					}
					return acc;
				}, []);

				const formData = {
					alphabet: alphabet || [],
					abcWords: sortedArrayAlphabet || []
				};

				yield put(actionsCreator.getABCSuccess(formData));
			}
		} catch (e) {
			console.log('CATCH ERROR getABCWatcher: ', e);
		}
	}
}
